import React from "react";
import {classNames} from "../../../../util/util-helpers"
import Tooltip from "../../../tooltip";

export default function PageHeader({
                                       className,
                                       title,
                                       buttonLabel,
                                       onButtonClick,
                                       buttonDisabled,
                                       buttonHidden,
                                       secondaryButtonLabel,
                                       onSecondaryButtonClick,
                                       secondaryButtonDisabled,
                                       secondaryButtonHidden,
                                       secondaryButtonTooltip,
                                       customHtml,
                                       titleClass,
                                       buttonsClassName,
                                       afterTitle,
                                       children
                                   }) {
    return (
        <header className={classNames(className ?? "flex")}>
            <h1 className={titleClass ?? "text-2xl flex items-center"}>
                {title}

                {afterTitle}
            </h1>

            <div className={classNames(buttonsClassName ?? "ml-auto space-x-3 flex")}>
                {customHtml}
                {children}

                {!!secondaryButtonLabel && !secondaryButtonHidden && (
                    <Tooltip
                        disabled={!secondaryButtonTooltip}
                        content={secondaryButtonTooltip}
                    >
                        <span>
                            <button
                                className={`btn btn-outline-secondary`}
                                onClick={() => {
                                    !secondaryButtonDisabled && onSecondaryButtonClick();
                                }}
                                disabled={secondaryButtonDisabled}
                            >
                                {secondaryButtonLabel}
                            </button>
                        </span>
                    </Tooltip>
                )}

                {!!buttonLabel && !buttonHidden && (
                    <button
                        id="create-btn"
                        className={`btn btn-primary`}
                        onClick={() => {
                            if (!buttonDisabled) {
                                onButtonClick();
                            }
                        }}
                        disabled={buttonDisabled}
                    >
                        {buttonLabel}
                    </button>
                )}
            </div>
        </header>
    )
}
